import Login from  './Login.vue';
import Lock from './Lock.vue';
import Logout from './Logout.vue';

export default{
	Login,
	Lock,
	Logout
}